// Application Access
export * from "./elearning.component";
export * from "./elearning.service";


// WEBPACK FOOTER //
// ./src/app/modules/userHome/reports/elearning/index.ts